var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.313 5.857c1.508 0 2.955.587 4.021 1.632A5.514 5.514 0 0 1 17 11.429c0 1.477-.6 2.894-1.666 3.94A5.748 5.748 0 0 1 11.313 17H8.25v-1.714h3.063c2.187 0 3.937-1.715 3.937-3.857 0-2.143-1.75-3.858-3.938-3.858h-4.96l2.694 2.649-1.233 1.209L3 6.714 7.813 2l1.242 1.209-2.704 2.648h4.962ZM4.75 15.286H6.5V17H4.75v-1.714Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.cda693f4.svg";
export { ForwardRef as ReactComponent };